import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.35323 7.52831C8.96753 6.73808 9.33333 5.74509 9.33333 4.66667C9.33333 2.08934 7.24399 0 4.66667 0C2.08934 0 0 2.08934 0 4.66667C0 7.244 2.08934 9.33333 4.66667 9.33333C5.74507 9.33333 6.73804 8.96754 7.52827 8.35327L10.6709 11.4959L11.4958 10.6709L8.35323 7.52831ZM8.16667 4.66667C8.16667 6.59966 6.59966 8.16667 4.66667 8.16667C2.73367 8.16667 1.16667 6.59966 1.16667 4.66667C1.16667 2.73367 2.73367 1.16667 4.66667 1.16667C6.59966 1.16667 8.16667 2.73367 8.16667 4.66667Z"
	})
});
export default SvgMagnifyingGlass;
